// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__8Zkg_","header":"ErrorPage_header__Nyjd4","headerMsg":"ErrorPage_headerMsg__H3aCq","content":"ErrorPage_content__x9OHk"};